import React from 'react';

import { Link, Text } from '@auspost/postmaster-react';

import ScanIcon from 'assets/scan.svg';
import { extLnkCheckID } from 'config/track-config';

import { trackInteraction } from '../../../../../../store/analytics/analytics.thunks';
import { useAppDispatch } from '../../../../../../store/store';
import QrCodeModal from '../QrCodeModal/QrCodeModal';

import styles from './ParcelCollectCTA.module.scss';

const ParcelCollectCTA: React.FC<{ trackingId: string }> = ({ trackingId }) => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const modalContent = (
    <>
      <Text variant='body-small' className={styles.modalText}>
        Show this QR code at the counter along with your&nbsp;
        <Link variant='text' href={extLnkCheckID} target='_blank'>
          proof of identity
        </Link>
        .
      </Text>
    </>
  );

  return (
    <>
      <button
        className={styles.qrCodeButton}
        onClick={() => {
          dispatch(trackInteraction('view collection QR code'));
          setIsModalOpen(true);
        }}
      >
        <ScanIcon aria-hidden />
        View collection QR code
      </button>
      <QrCodeModal
        qrCode={trackingId}
        isOpen={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        heading='Collection QR code'
        content={modalContent}
      ></QrCodeModal>
    </>
  );
};

export default ParcelCollectCTA;
